// @flow strict

import _ from 'lodash';
import type { ToggleItemType } from 'types/toggleItemType.flow';
import {
  isValidAlienNumber,
  isValidCategoryCode,
  isValidEmployerName,
  isValidGreenCardNumber,
  isValidI94Number,
  isValidOtherDocumentTypeText,
  isValidPassportNumber,
  isValidSevisId,
} from 'client/utils/validate';

export const REQUIRED_FIELD_ERROR_PATH = 'common.form.error.required';

export type ValidationErrorType = { path: string } | typeof undefined;

// isEmpty checks allows user to proceed without answering optional question
export const alienNumberValidation = [
  (val: string) =>
    (_.isEmpty(val) || isValidAlienNumber(val)
      ? undefined
      : { path: 'common.form.error.alienNumber' }),
];

export const greenCardNumberValidation = [
  (val: string) =>
    (_.isEmpty(val) || isValidGreenCardNumber(val)
      ? undefined
      : { path: 'ede.error.form.immigration.greenCard.cardNumber' }),
];

export const requiredLengthValidation = [
  (val: Array<ToggleItemType>) =>
    (val.length > 0 ? undefined : { path: REQUIRED_FIELD_ERROR_PATH }),
];

export const passportNumberValidation = [
  (val: string) =>
    (_.isEmpty(val) || isValidPassportNumber(val)
      ? undefined
      : { path: 'ede.error.form.immigration.passportNumber' }),
];

export const i94NumberValidation = [
  (val: string) =>
    (_.isEmpty(val) || isValidI94Number(val)
      ? undefined
      : { path: 'ede.error.form.immigration.i94Number' }),
];

export const categoryCodeValidation = [
  (val: string) =>
    (_.isEmpty(val) || isValidCategoryCode(val)
      ? undefined
      : { path: 'ede.error.form.immigration.categoryCode' }),
];

export const sevisIdValidation = [
  (val: string) =>
    (_.isEmpty(val) || isValidSevisId(val)
      ? undefined
      : { path: 'ede.error.form.immigration.sevisId' }),
];

export const otherDocumentTypeTextValidation = (val: string) =>
  (_.isEmpty(val) || isValidOtherDocumentTypeText(val)
    ? undefined
    : { path: 'ede.error.form.immigration.otherDocumentTypeText' });

export const employerNameValidation = (val: string) =>
  (_.isEmpty(val) || isValidEmployerName(val) ? undefined : { path: 'ede.error.form.employerName' });

export const BOOLEAN_VALIDATION = [
  val => (val === true || val === false ? undefined : { path: 'common.form.error.required' }),
];
